/* Scene cues fired ONLY by real events: a real tool starting, a real completion, a real failure.
   No timers, no demo progress — the backdrop reacts to work that actually happened.
   `motif` (optional) themes the scan to the kind of real work: mail | calendar | document | research. */
const EVT = "jarvis-scene";

export const sceneCue = (type, motif = "") => window.dispatchEvent(new CustomEvent(EVT, { detail: { type, motif } }));
export const onSceneCue = (fn) => {
  const h = (e) => fn(e.detail || {});
  window.addEventListener(EVT, h);
  return () => window.removeEventListener(EVT, h);
};

/* Map a real tool name or a real navigation target to a background motif. Returns "" for unknown
   so the backdrop falls back to the neutral scan (never invents a theme). */
export const motifFor = (nameOrScreen = "") => {
  const s = String(nameOrScreen).toLowerCase();
  if (s.startsWith("gmail") || s === "emails" || s.startsWith("automation")) return "mail";
  if (s.startsWith("calendar")) return "calendar";
  if (["proposals", "files", "projects", "clients", "tasks", "find_records", "open_record"].some((k) => s.includes(k))) return "document";
  if (s.includes("research") || s.includes("search") || s.includes("summary") || s === "today") return "research";
  return "";
};
